import {
  TUG_LIST_GET_SUCCESS,
  TUG_GET_SUCCESS,
  TUG_CREATE_SUCCESS,
  TUG_UPDATE_SUCCESS,
  TUG_UPDATE_ERROR,
  TUG_DELETE_SUCCESS,
  TUG_DELETE_ERROR,
} from 'src/store/tug/actions'
import { getIdsFromList, getByIdFromList } from 'src/utils/store'

export const getInitialState = {
  status: null,
  data: null,
  error: null,
  byId: null,
  statusById: null,
  errorById: null,
}

export const reducer = (state = getInitialState, action) => {
  const { type, payload } = action
  const { uuid } = typeof payload === 'string' ? payload : payload || {}

  switch (type) {
    case TUG_LIST_GET_SUCCESS:
      return {
        ...state,
        data: getIdsFromList(payload),
        byId: getByIdFromList(payload),
        statusById: getIdsFromList(payload).reduce(
          (status, id) => ({
            ...status,
            [id]: type,
          }),
          {}
        ),
        errorById: {},
      }
    case TUG_GET_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: data.indexOf(uuid) > -1 ? data : [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case TUG_CREATE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case TUG_UPDATE_SUCCESS: {
      const { byId, statusById, ...restState } = state
      return {
        ...restState,
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case TUG_UPDATE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: payload,
        },
      }
    }
    case TUG_DELETE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      delete byId[uuid]
      return {
        ...restState,
        data: data.filter((id) => id !== uuid),
        byId: { ...byId },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case TUG_DELETE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: payload,
        },
      }
    }
    default:
      return state
  }
}

export default reducer
